module.exports = __webpack_public_path__ + "img/word.15321b1c.png";